// @flow

// Pull prefetchCompletion off the window object if one exists for this link.
// Note: this function returns percentage as a string, not a number!

export default function getPrefetchCompletionPercent(link: string) {
  // if prefetch hasn't started, return 0 to indicate 0% was downloaded
  if (!window || !window.prefetchCompletion || !window.prefetchCompletion[link]) {
    return '0';
  }

  const { downloadedAssets, totalAssets } = window.prefetchCompletion[link];

  // if there are no assets, return -1 for logging purposes
  if (!totalAssets) {
    return '-1';
  }

  return ((downloadedAssets / totalAssets) * 100).toFixed(3).toString();
}
